export class NumberFormatter {
    private numberPrefix = new Map<NumberType, string>([
        [NumberType.price, '$'],
        [NumberType.bitcoinPrice, '₿'],
        [NumberType.ethereumPrice, 'Ξ'],
    ])

    defaultFormat(number: number, type: NumberType | undefined = undefined): string {
        const prefixString = type ? this.numberPrefix.get(type) || '' : '';
        const absNumber = Math.abs(number);

        const thresholds = [
            { value: 1e15, suffix: 'q' },
            { value: 1e12, suffix: 't' },
            { value: 1e9,  suffix: 'b' },
            { value: 1e6,  suffix: 'm' },
            { value: 1e3,  suffix: 'k' }
        ];

        const match = thresholds.find(t => absNumber >= t.value);

        const formatted = match
            ? (absNumber / match.value).toFixed(2) + match.suffix
            : absNumber.toFixed(2);

        return prefixString + (number < 0 ? '-' : '') + formatted;
    }

    percentFormat(number: number) : string {
        return number.toFixed(2) + '%'
    }
}

export enum NumberType {
    number = 'number',
    price = 'price',
    percent = 'percent',
    bitcoinPrice = 'bitcoinPrice',
    ethereumPrice = 'ethereumPrice',
}

export const numberFormatters = new NumberFormatter()